export const generateStyleVariables = (
  styles: Record<string, string | number | null | undefined> = {}
): Record<string, string | number> => {
  const cssVars: Record<string, string | number> = {}

  Object.entries(styles || {}).forEach(([property, value]) => {
    if (value != null && value !== "") {
      cssVars[`--mvt-${property}`] = standardizeStyle(property, value) as
        | string
        | number
    }
  })

  return cssVars
}

const standardizeStyle = (property: string, value: string | number) => {
  if (property.includes("height")) {
    return generateCssHeight(value)
  }

  return value
}

const generateCssHeight = (height: string | number): string | number => {
  if (typeof height !== "string" || !height.includes("%")) {
    return height
  }

  const multiplier = parseInt(height) / 100
  return `calc(var(${APP_HEIGHT_INITIAL_CSS_VAR}) * ${multiplier})`
}

export const APP_HEIGHT_INITIAL_CSS_VAR = "--app-height-initial"
